<div class="service-container">
  <div class="search-bar">
    <input type="text" placeholder="Search services" [(ngModel)]="searchTerm" (input)="search()">
    <button class="search-button" (click)="search()">
      <img src="assets/icon-search.png" alt="Search">
    </button>
  </div>
  <div class="service-list">
    <div *ngFor="let item of filteredServiceItems" class="service-item" (click)="getServices(item.title)">
      <div class="icon-container">
        <img src="assets/icon-service.png" alt="" class="item-icon">
      </div>
      <div class="item-title">{{ item.title }}</div>
    </div>
  </div>
</div>
